export default [
    {
      path: '/report/portfolios',
      name: 'report-portfolios',
      component: () => import('@/views/reports/portfolio/Portfolio.vue'),
      meta: {
        // pageTitle: 'Settings',
        // breadcrumb: [
        //   {
        //     text: 'Settings',
        //     active: true,
        //   },
        // ],
        action: 'read',
        Permission: 'no_permission_required',
      },
    },
    {
        path: '/report/statements',
        name: 'report-statements',
        component: () => import('@/views/reports/statement/Statement.vue'),
        meta: {
          action: 'read',
          Permission: 'no_permission_required',
        },
      },
    {
        path: '/report/transaction-statement',
        name: 'report-transaction-statement',
        component: () => import('@/views/reports/transaction-statement/TransactionStatement.vue'),
        meta: {
          action: 'read',
          Permission: 'no_permission_required',
        },
      },
    {
        path: '/report/infina-report',
        name: 'report-infina',
        component: () => import('@/views/reports/infina-report/InfinaReport.vue'),
        meta: {
          action: 'read',
          Permission: 'no_permission_required',
          requiresInfinaReport: true,
        },
      },
    {
        path: '/report/intesa-report',
        name: 'report-intesa',
        component: () => import('@/views/reports/intesa-report/IntesaReport.vue'),
        meta: {
          action: 'read',
          Permission: 'no_permission_required',
          requiresIntesaReport: true,
        },
      },
    {
        path: '/report/azimut-report',
        name: 'report-azimut',
        component: () => import('@/views/reports/azimut-report/AzimutReport.vue'),
        meta: {
          action: 'read',
          Permission: 'no_permission_required',
          requiresAzimutReport: true,
        },
      },
    {
        path: '/report/kare-infina-report',
        name: 'report-kare-infina',
        component: () => import('@/views/reports/kare-infina-report/KareInfinaReport.vue'),
        meta: {
          action: 'read',
          Permission: 'no_permission_required',
          requiresKareInfinaReport: true,
        },
      },

  ];
  